import Net from '../../util/net';
import {
  GetGroupListReq,
  GetGroupListRsp,
  GroupDataType,
  GetGroupListPosReq,
  GetGroupListPosRsp,
  GetGroupInfoReq,
  GetGroupInfoRsp,
  JoinGroupReq,
  JoinGroupRsp,
  ApplyToGroupReq,
  ApplyToGroupRsp,
  CheckShareValidReq,
  CheckShareValidRsp,
  ChannelInfo,
  GetChannelInfoReq,
  GetChannelInfoRsp,
  EnterGuestModeReq,
  EnterGuestModeRsp,
  GetGrpShareParamReq,
  GetGrpShareParamRsp,
  QuitGroupReq,
  QuitGroupRsp,
  GetAdvConfRsp,
  GetAdvConfReq,
  GetEntranceConfReq,
  GetEntranceConfRsp,
  FoldChannnelCateReq,
  FoldChannnelCateRsp,
  ChanCateBaseInfo,
  GetGrpRandShareTxtRsp,
  GetGrpRandShareTxtReq,
  Platform,
  UpdateGroupNickRsp,
  UpdateGroupNickReq,
  GetChannelBlockInfoRsp,
  GetChannelBlockInfoReq,
  GetSendMsgBlockListReq,
  GetSendMsgBlockListRsp,
} from '../../typings/proto';
import { TRequest } from '../../util/net/typings';

export interface IGetGroupListParams {
  type: GroupDataType;
  page: number;
  pageSize: number;
}

export default {
  getGroupList({ type = 1, page = 1, pageSize = 50 }: IGetGroupListParams): Promise<GetGroupListRsp> {
    return Net.request<GetGroupListRsp, GetGroupListReq>({
      path: 'knockknock.GroupUserBaseSrv/GetGroupList',
      data: {
        page,
        pageSize,
        type,
        needChannel: true,
        needUserGrpStatistics: true,
      },
    });
  },
  getGroupListPos(): Promise<GetGroupListPosRsp> {
    return Net.request<GetGroupListPosRsp, GetGroupListPosReq>({
      path: 'knockknock.GroupUserBaseSrv/GetGroupListPos',
      data: {},
    });
  },
  getGroupInfo(data: TRequest<GetGroupInfoReq>): Promise<GetGroupInfoRsp> {
    return Net.request<GetGroupInfoRsp, GetGroupInfoReq>({
      path: 'knockknock.GroupBaseSrv/GetGroupInfo',
      data: data || {},
    });
  },
  joinGroup(gid: string, { shareToken = '' }: { shareToken?: string } = {}): Promise<JoinGroupRsp> {
    return Net.request<JoinGroupRsp, JoinGroupReq>({
      path: 'knockknock.GroupJoinSrv/JoinGroup',
      data: {
        gid,
        shareToken: shareToken ?? '',
      },
      autoHandleError: false,
    });
  },
  ApplyToGroup({ gid, applyReason }: {gid: string, applyReason: string}): Promise<ApplyToGroupRsp> {
    return Net.request<ApplyToGroupRsp, ApplyToGroupReq>({
      path: 'knockknock.GroupJoinSrv/ApplyToGroup',
      data: {
        gid,
        applyReason,
      },
    });
  },
  CheckShareValid({ token, gid }: { token: string, gid: string}): Promise<CheckShareValidRsp> {
    return Net.request<CheckShareValidRsp, CheckShareValidReq>({
      path: 'knockknock.GroupShareSrv/CheckShareValid',
      data: {
        token,
        gid,
      },
    });
  },
  /** 批量获取频道拓展信息 */
  getChannelInfo(ids: string[]): Promise<Array<ChannelInfo>> {
    return Net.request<GetChannelInfoRsp, GetChannelInfoReq>({
      path: 'knockknock.GroupSrv/GetChannelInfo',
      data: {
        channelId: ids,
        channelIdStr: [],
        needExtInfo: true,
      },
    }).then(data => data.channelInfo);
  },
  /** 预览模式加入群组 */
  enterGroupInGuestMode(gid: string, shareToken?: string): Promise<EnterGuestModeRsp> {
    return Net.request<EnterGuestModeRsp, EnterGuestModeReq>({
      path: 'knockknock.GroupGuestSrv/EnterGuestMode',
      data: {
        gid,
        shareToken,
      },
    });
  },
  getGrpShareParam(gid: string): Promise<GetGrpShareParamRsp> {
    return Net.request<GetGrpShareParamRsp, GetGrpShareParamReq>({
      path: 'knockknock.GroupShareSrv/GetGrpShareParam',
      data: {
        gid,
      },
    });
  },
  quitGroup(gid: string, uid?: string): Promise<QuitGroupRsp> {
    return Net.request<QuitGroupRsp, QuitGroupReq>({
      path: 'knockknock.GroupBaseSrv/QuitGroup',
      data: {
        gid,
        uid,
      },
    });
  },
  getGroupPromotionInfo(gidList: Array<string>, platform = Platform.PlatformWeb): Promise<GetAdvConfRsp> {
    return Net.request<GetAdvConfRsp, GetAdvConfReq>({
      path: 'knockknock.CentreConfigSrv/GetAdvConf',
      data: {
        gid: gidList,
        plat: platform,
      },
    });
  },
  getGroupCenterEntranceInfo(gidList: Array<string>, platform = Platform.PlatformWeb): Promise<GetEntranceConfRsp> {
    return Net.request<GetEntranceConfRsp, GetEntranceConfReq>({
      path: 'knockknock.CentreConfigSrv/GetEntranceConf',
      data: {
        gid: gidList,
        plat: platform,
      },
    });
  },
  setChannelFoldList(gid: string, arr: Array<ChanCateBaseInfo>): Promise<FoldChannnelCateRsp> {
    return Net.request<FoldChannnelCateRsp, FoldChannnelCateReq>({
      path: 'knockknock.GroupChannelCateSrv/FoldChannnelCate',
      data: {
        gid,
        caids: arr,
      },
    });
  },
  getRandShareTxt(gid: string): Promise<GetGrpRandShareTxtRsp> {
    return Net.request<GetGrpRandShareTxtRsp, GetGrpRandShareTxtReq>({
      path: 'knockknock.GroupShareSrv/GetGrpRandShareTxt',
      data: {
        gid,
      },
    });
  },
  setGroupNick(gid: string, nick: string): Promise<UpdateGroupNickRsp> {
    return Net.request<UpdateGroupNickRsp, UpdateGroupNickReq>({
      serverName: 'GroupMinorSrv',
      funcName: 'UpdateGroupNick',
      data: {
        gid, nick,
      },
    });
  },
  getChannelBlockInfo(cid: string): Promise<GetChannelBlockInfoRsp> {
    return Net.request<GetChannelBlockInfoRsp, GetChannelBlockInfoReq>({
      path: 'knockknock.GroupChannelSrv/GetChannelBlockInfo',
      data: {
        cid,
      },
    });
  },
  getSendMsgBlockList(cid: string, blockType: number): Promise<GetSendMsgBlockListRsp> {
    return Net.request<GetSendMsgBlockListRsp, GetSendMsgBlockListReq>({
      path: 'knockknock.GroupChannelSrv/GetSendMsgBlockList',
      data: {
        cid,
        blockType,
        size: 200,
        needUserInfo: false,
        context: '',
      },
    });
  },
};
